<template>
  <span aria-hidden="true">&#8226;</span>
</template>
